// Click a post image to open it enlarged over a dimmed backdrop.
// Click anywhere (or press Escape) to close. No external library.
export default function lightbox() {
    const selector = ".gh-content .kg-image, .gh-content .kg-gallery-image img, .gh-feature-image img";
    const images = document.querySelectorAll(selector);
    if (!images.length) return;

    // Build the overlay once and reuse it.
    const overlay = document.createElement("div");
    overlay.className = "gh-lightbox";
    overlay.setAttribute("aria-hidden", "true");
    overlay.innerHTML =
        '<button class="gh-lightbox-close" type="button" aria-label="Close">&times;</button>' +
        '<img class="gh-lightbox-img" alt="">';
    document.body.appendChild(overlay);

    const overlayImg = overlay.querySelector(".gh-lightbox-img");

    function open(img) {
        // currentSrc resolves the size the browser actually picked from srcset.
        overlayImg.src = img.currentSrc || img.src;
        overlayImg.alt = img.alt || "";
        overlay.classList.add("is-open");
        overlay.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
    }

    function close() {
        overlay.classList.remove("is-open");
        overlay.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
    }

    images.forEach((img) => {
        // Leave linked images alone — a click should follow the link.
        if (img.closest("a")) return;
        img.classList.add("gh-zoomable");
        img.addEventListener("click", () => open(img));
    });

    overlay.addEventListener("click", close);
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && overlay.classList.contains("is-open")) close();
    });
}
